module.exports = __webpack_public_path__ + "assets/children-unselected.f67fbaeae9633e06d9eb0cc9c1a04d05.svg";